import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const WebsitePayload = RepositoryFactory.get("websiteRole");

export default {
  createWebsitePayload({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await WebsitePayload.create(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getWebsitePayload({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await WebsitePayload.get(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateWebsitePayload({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await WebsitePayload.update(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteWebsitePayload({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await WebsitePayload.delete(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
